import * as Yup from 'yup';

export const addEditJobDesignationSchema = Yup.object({
  designation: Yup.string()
    .trim()
    .required('Designation is required.')
    .max(30, 'Must be 30 characters or less')
    .matches(/^(\w+\s?)*\w+$/, 'Multiple spaces between words are not allowed.')
});

export const addEditTechnologySchema = Yup.object({
  technology: Yup.string()
    .trim()
    .required('Technology is required.')
    .max(100, 'Must be 100 characters or less'),
  parameter: Yup.array()
    .of(Yup.string('Parameter should be type of string.'))
    .required('Parameter is required.')
    .min(0, 'Minimum 0 Parameter is required.'),
  technologyColor: Yup.string()
    .required('Technology color is required.')
    .trim()
    .min(6, 'Minimun 6 Characters is required.')
    .max(7, 'Minimun 6 Characters is required.'),
  technologyDarkModeColor: Yup.string()
    .required('Technology color is required.')
    .trim()
    .min(6, 'Minimun 6 Characters is required.')
    .max(7, 'Minimun 6 Characters is required.')
});

export const addEditJobDescriptionSchema = Yup.object({
  name: Yup.string().trim().required('Name is required.'),
  subject: Yup.string().trim().required('Subject is required.'),
  description: Yup.string().trim().required('Description is required.')
});

export const addEditEmailTemplateSchema = Yup.object({
  name: Yup.string().trim().required('Name is required.'),
  subject: Yup.string().trim().required('Subject is required.'),
  description: Yup.string().trim().required('Description is required.')
});

export const addEditCommonParameterSchema = Yup.object({
  parameterName: Yup.string()
    .required('Parameter is required.')
    .max(100, 'Must be 100 characters or less'),
  subParameterIds: Yup.array().when('isGroupParameter', {
    is: true,
    then: Yup.array()
      .of(Yup.string('Should be of type string.'))
      .min(1, 'Please add at least one Parameter.')
      .required('Sub Parameters are required.'),
    otherwise: Yup.array().notRequired()
  })
});
